import { render, staticRenderFns } from "./SupersetCardItem.vue?vue&type=template&id=3320f983&"
import script from "./SupersetCardItem.vue?vue&type=script&lang=js&"
export * from "./SupersetCardItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports